import { call, put, takeLatest, } from 'redux-saga/effects';
import { Urls } from 'src/common/urls';
import * as Actions from './action';
import * as ActionTypes from './actionTypes';
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider';
import { getErrorFromResponse } from 'src/features/Security/networking/util';
import { ExpenditureRecordsFilters } from 'src/common/models/expenditureRecord';
import { PayableContractDebitRecordsFilters } from 'src/common/models/payableContractDebit';
import { PayableContractPaymentRecordsFilters } from 'src/common/models/payableContractDebitPayment';

const buildQueryString = (filters?: ExpenditureRecordsFilters): string => {
    const filtersList: string[] = []
    if (filters?.dateFrom && filters?.dateTo) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
        filtersList.push(`dateTo=${filters.dateTo}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getExpenditureRecordsApi(action: Actions.GetExpenditureRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.EXPENDITURE_RECORD.GET_RECORDS(buildQueryString(action.filters)))
        yield put(Actions.getExpenditureRecordsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getExpenditureRecordsApiError(getErrorFromResponse(err)));
    }
}

function* createExpenditureRecordApi(action: Actions.CreateExpenditureRecordAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.EXPENDITURE_RECORD.CREATE, action.expenditureRecord)
        yield put(Actions.createExpenditureRecordApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createExpenditureRecordApiError(getErrorFromResponse(err)));
    }
}

const buildDebitsQueryString = (filters?: PayableContractDebitRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.status) {
        filtersList.push(`status=${filters.status}`)
    }
    if (filters?.payableContractId) {
        filtersList.push(`payableContractId=${filters.payableContractId}`)
    }
    if (filters?.supplierId) {
        filtersList.push(`supplierId=${filters.supplierId}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getPayableDebitRecordsApi(action: Actions.GetPayableContractDebitsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.PAYABLE_CONTRACT_DEBIT.GET_RECORDS(buildDebitsQueryString(action.filters)))
        yield put(Actions.getPayableContractDebitsApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getPayableContractDebitsApiError(getErrorFromResponse(err)));
    }
}

function* getPayableDebitByIdApi(action: Actions.GetPayableDebitByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.PAYABLE_CONTRACT_DEBIT.GET_BY_ID(action.id))
        yield put(Actions.getPayableDebitByIdApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getPayableDebitByIdApiError(getErrorFromResponse(err)));
    }
}

function* createPayableDebitPaymentApi(action: Actions.CreatePayableDebitPaymentAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.PAYABLE_CONTRACT_DEBIT_PAYMENT.CREATE, action.contractPayment)
        yield put(Actions.createPayablePaymentApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.createPayablePaymentApiError(getErrorFromResponse(err)));
    }
}

const buildContractPaymentsQueryString = (filters?: PayableContractPaymentRecordsFilters) => {
    const filtersList: string[] = []
    if (filters?.dateFrom) {
        filtersList.push(`dateFrom=${filters.dateFrom}`)
    }
    if (filters?.dateTo) {
        filtersList.push(`dateTo=${filters.dateTo}`)
    }

    return filtersList.length > 0
        ? `?${filtersList.join('&')}`
        : ``
}

function* getPayableContractPaymentRecordsApi(action: Actions.GetPayableContractPaymentRecordsAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.PAYABLE_CONTRACT_DEBIT_PAYMENT.GET_RECORDS(buildContractPaymentsQueryString(action.filters)))
        yield put(Actions.getPayableContractPaymentRecordsApiSuccess(
            response.data
        ))
    } catch (err) {
        yield put(Actions.getPayableContractPaymentRecordsApiError(getErrorFromResponse(err)));
    }
}

function* deletePayableContractDebitApi(action: Actions.DeletePayableContractDebitAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.PAYABLE_CONTRACT_DEBIT.DELETE, { id: action.id })
        yield put(Actions.deletePayableContractDebitApiSuccess(
            response.data
        ))
    } catch (err) {
        yield put(Actions.deletePayableContractDebitApiError(getErrorFromResponse(err)));
    }
}

export default function* accountPayablesSagas() {
    yield takeLatest(ActionTypes.GET_EXPENDITURE_RECORDS_API, getExpenditureRecordsApi)
    yield takeLatest(ActionTypes.CREATE_EXPENDITURE_RECORD_API, createExpenditureRecordApi)
    yield takeLatest(ActionTypes.GET_PAYABLE_CONTRACT_DEBITS_API, getPayableDebitRecordsApi)
    yield takeLatest(ActionTypes.GET_PAYABLE_DEBIT_BY_ID_API, getPayableDebitByIdApi)
    yield takeLatest(ActionTypes.CREATE_PAYABLE_DEBIT_PAYMENT_API, createPayableDebitPaymentApi)
    yield takeLatest(ActionTypes.GET_PAYABLE_CONTRACT_PAYMENTS_API, getPayableContractPaymentRecordsApi)
    yield takeLatest(ActionTypes.DELETE_PAYABLE_CONTRACT_DEBIT_API, deletePayableContractDebitApi)
}